import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getInitialLanguage } from './core/state/languageState';
import translationRu from './locales/ru/translation.json';
import translationPl from './locales/pl/translation.json';

const initialLanguage = getInitialLanguage();

i18n.use(initReactI18next).init({
  lng: initialLanguage,
  fallbackLng: 'ru',
  resources: {
    ru: {
      translation: translationRu,
    },
    pl: {
      translation: translationPl,
    },
  },
});

export default i18n;
